module.exports = __webpack_public_path__ + "img/link-home-img.cc2edcad.png";